export const HIDE_OVERLAYS = 'ui/HIDE_OVERLAYS'
